import React, { Fragment } from 'react';

import FieldModal from '../../modals/fieldModal';
import API from '../../../utils/API';

import InputField from '../../../components/inputs/inputField';

class RenameVenueModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: props.venue.name,
            submitting: false,
            complete: false,
            requiredFields: {
                name: false,
            }
        };
    }

    handleNameChange = (e) => {
        this.setState({
            name: e.target.value
        });
    };

    submit = async () => {
        const { name } = this.state;
        const { renameVenue, venue } = this.props;
        let valid = true;
        let requiredFields = this.state.requiredFields;
        if (!name) {
            requiredFields.name = true;
            valid = false;
        } else {
            requiredFields = false;
        }

        if (valid) {

            this.setState({ submitting: true })


            await API().patch(`Organizations/${this.props.orgId}/venues/${venue._id}`, { name }).then((res) => {
                if (res.data) {
                    renameVenue(res.data)
                    this.setState({ submitting: false, complete: true })
                }
            });


        } else {

            this.setState({ requiredFields: requiredFields })
        }


    }

    render() {
        const { isOpen, toggle } = this.props;
        const { name, submitting, requiredFields, complete } = this.state;
        return (

            <div>



                <FieldModal
                    size="medium"
                    isOpen={isOpen}
                    modalTitle={"Rename Venue"}
                    bodyHeaderText={''}
                    bodyDescription={''}
                    bodyContent={() => {
                        return (
                            <div>
                                <InputField
                                    label="Venue Name"
                                    required={true}
                                    disabled={complete}
                                    errorTrigger={requiredFields.name}
                                    value={name}
                                    type="name"
                                    onChange={this.handleNameChange}
                                />
                            </div>)
                    }}
                    toggle={toggle}
                    actionButtonLabel={!submitting && !complete ? 'Submit' : submitting && !complete ? 'Adding...' : complete ? '' : ''}
                    actionButton={() => this.submit()}
                    actionButtonDisabled={submitting || complete}
                    cancelButtonLabel={complete ? 'Close' : 'Cancel'}



                ></FieldModal>
            </div>

        );
    }
}

export default RenameVenueModal;
